import { render, staticRenderFns } from "./composeEmailPopup.vue?vue&type=template&id=6aa61aa9&"
import script from "./composeEmailPopup.vue?vue&type=script&lang=js&"
export * from "./composeEmailPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports